var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffa600"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#gradient)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 14,
    rx: 10,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,14 v8 M30,14 v8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 22,
    rx: 10,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,22 v8 M30,22 v8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 30,
    rx: 10,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,30 v8 M30,30 v8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 38,
    rx: 10,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,10 h9 v9 l-16,16 l-9,-9 z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 15,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 23,
    x2: 38,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: 26,
    x2: 35,
    y2: 20
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.1bc8f5df408059918f90f97d1a5b8ef0.svg";
export { ForwardRef as ReactComponent };